// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_2_wrapper__3FFdp"};